import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {userService} from "../../../services"
import User from "../../../components/user/Profile"
import ErrorModal from "../../../components/UI/Error";
import Spinner from "../../../components/UI/Spinner";
const ArtistProfilePage = () => {
  const { id } = useParams();
  const [artist, setArtist] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]= useState(false)
  useEffect(() => {
    const fetchArtist = async () => {
      try {
        setError(false)
     const userData= await userService.myProfile(id)
        setArtist(userData);
      } catch (error) {
        setError(true)
        console.error("Error fetching artist:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchArtist();
  }, [id]);

  if(loading) return <div className="grid place-content-center h-[60vh]"><Spinner/></div>
  if(error) return <ErrorModal isOpen={error} onClose={()=>setError(false)} title={"Error Fetching Artiste"} message={"There is error while trying to fetch the artiste's details. Please check your internet contivities and refresh this page to try again"} />
  
  return (
  <User user={artist} editProfile={`/admin/users/profile/edit-user/${artist._id}`}/>
  );
};

export default ArtistProfilePage;
